import { barChartOptionsDashboard } from "layouts/dashboard/data/barChartOptions";
import React, { Component } from "react";
import Chart from "react-apexcharts";


class BarChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chartData: [],
      chartOptions: {},
    };
  }

  componentDidMount() {
    const { chartData, chartCategories } = this.props;

    this.setState({
      chartData: chartData,
      chartOptions: {
          ...barChartOptionsDashboard,
          xaxis: {
            ...barChartOptionsDashboard.xaxis,
            categories: chartCategories,
          },
        }
    });
  }

  componentDidUpdate(prevProps) {
    const { chartData, chartCategories } = this.props;

    if (prevProps.chartData !== chartData) {
      this.setState({ chartData: chartData });
    }

    if (prevProps.chartCategories !== chartCategories) {
      this.setState(prevState => ({
        chartOptions: {
          ...prevState.chartOptions,
          xaxis: {
            ...prevState.chartOptions.xaxis,
            categories: chartCategories,
          },
        },
      }));
    }
  }

  render() {
    return (
      <Chart
        options={this.state.chartOptions}
        series={this.state.chartData}
        type="bar"
        width="100%"
        height="100%"
      />
    );
  }
}

export default BarChart;
